import React, {useEffect, useState} from 'react';
import {getSongSearchState, subscribeSongSearchState, rebuildSearchIndex} from '../../services/songs-db';

export const useSongSearchState = () => {
  const readState = () => getSongSearchState?.() || {status: 'ready', progress: 100};
  const [state, setState] = useState(readState);
  useEffect(() => {
    setState(readState());
    return subscribeSongSearchState?.(() => setState(readState()));
  }, []);
  return state;
};

export const SearchIndexStatusComponent = ({state}) => {
  const messages = {missing: 'Indeks piosenek nie jest jeszcze gotowy.',
    indexing: `Indeksowanie piosenek: ${state.progress}%. Poczekaj na wyniki.`,
    dirty: 'Biblioteka zmieniła się. Odśwież indeks, aby wyszukać aktualne wersje.',
    error: 'Nie udało się odświeżyć indeksu. Poprzednie wyniki pozostają dostępne.'};
  return <div className="search-index-status">
    {state.status !== 'ready' && <span role="status">{messages[state.status]}</span>}
    {state.status === 'indexing' && <progress aria-label="Postęp indeksowania" max="100" value={state.progress} />}
    <button type="button" onClick={() => rebuildSearchIndex()} disabled={state.status === 'indexing'}>
      {state.status === 'error' ? 'Ponów indeksowanie' : 'Odśwież indeks'}
    </button>
  </div>;
};
